/* Mobile menu burger toggle */
(function () {
    // eslint-disable-next-line no-undef
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) {
        return;
    }

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            // eslint-disable-next-line no-undef
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            // eslint-disable-next-line no-undef
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    // eslint-disable-next-line no-undef
    lightbox('.kg-image-card > .kg-image[width][height], .kg-gallery-image > img');
})();

/* Responsive video in post content */
(function () {
    const sources = ['.gh-content iframe[src*="youtube.com"]', '.gh-content iframe[src*="youtube-nocookie.com"]', '.gh-content iframe[src*="player.vimeo.com"]', '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]', '.gh-content object', '.gh-content embed'];
    // eslint-disable-next-line no-undef
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    // eslint-disable-next-line no-undef
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    // eslint-disable-next-line no-undef
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        // eslint-disable-next-line no-undef
        pagination();
    }
})();

(function () {
    // eslint-disable-next-line no-undef
    if (document.querySelector('.gh-currency-page')) {
        // eslint-disable-next-line no-undef
        exchangeInit();
    }

    // eslint-disable-next-line no-undef
    if (document.querySelector('.gh-weather-page')) {
        // eslint-disable-next-line no-undef
        weatherInit();
    }

    // eslint-disable-next-line no-undef
    if (document.querySelector('.currency-feed')) {
        // eslint-disable-next-line no-undef
        infoInit();
    }

    // eslint-disable-next-line no-undef
    if (document.querySelector('.js-current-weather')) {
        // eslint-disable-next-line no-undef
        currentWeatherFill();
    }
})();

const adminBaseUrl = (window.location.origin)?.replace(/\/+$/, '');
const api = new GhostContentAPI({
    url: adminBaseUrl, key: 'ced70cdefa0d6288dc455640fe', version: 'v4'
});

let currentPage = 1;

let lastDate = null; // Track the last date to insert dividers

const container = document.querySelector('.gh-feed');

const elementsCards = document.querySelectorAll('.gh-feed > .date-divider');
if (elementsCards.length) {
    const lastElement = elementsCards[elementsCards.length - 1];
    lastDate = lastElement.innerText;
}

async function loadMorePosts() {
    // eslint-disable-next-line no-plusplus
    currentPage++;

    try {
        const result = await api.posts.browse({
            include: 'tags', limit: 14, order: 'published_at DESC', page: currentPage
        });

        result.forEach((post) => {
            const currentDate = timeAgo(post.published_at);
            let date1 = '';

            if (lastDate) {
                if (lastDate.split(',')[1]) {
                    date1 = lastDate.split(',')[1].trim();
                }
            }

            const date2 = currentDate.split(',')[1].trim();

            let dividerHTML = '';
            if (lastDate !== currentDate && date1 !== date2) {
                dividerHTML = `
                    <div class="date-divider">
                        <h2>${currentDate}</h2>
                    </div>
                `;
                lastDate = currentDate; // Update the last date
            }

            const imageUrl = post.feature_image;
            let srcset = '';
            let src = '';
            const featureImageAlt = post.feature_image_alt || post.title;
            const postTags = post.tags || [];

            if (imageUrl) {
                const urlObj = new URL(imageUrl);
                const imagePath = urlObj.pathname.replace('/content/images/', ''); // Trim unnecessary parts

                srcset = `
                    /content/images/size/w320/${imagePath} 300w,
                    /content/images/size/w600/${imagePath} 720w,
                    /content/images/size/w960/${imagePath} 960w,
                    /content/images/size/w1200/${imagePath} 1200w,
                    /content/images/size/w2000/${imagePath} 2000w
                `.trim();

                src = `/content/images/size/w600/${imagePath}`;
            }

            // eslint-disable-next-line array-callback-return
            const tagsHTML = postTags.map((tag) => {
                if (!['toate-stirile', 'hash-import-2025-03-07-14-17'].includes(tag.slug)) {
                    return `<span class="gh-tag js-tag-click" data-url="/tag/${tag.slug}/"><span class="gh-hashtag">#</span> ${tag.name}</span>`;
                }
            }).join('');

            const postHTML = `
                ${dividerHTML}
                <article class="gh-card">
                    <a class="gh-card-link" href="${post.url}">

                        ${imageUrl ? `
                        <figure class="gh-card-image">
                            <img
                                srcset="${srcset}"
                                sizes="(max-width: 1200px) 100vw, 1200px"
                                src="${src}"
                                alt="${featureImageAlt}">
                        </figure>
                        ` : ''}

                        <div class="gh-card-wrapper">
                            <header class="gh-card-header">
                                <h3 class="gh-card-title">${post.title}</h3>
                            </header>

                            <div class="gh-card-excerpt">
                                ${post.excerpt || ''}
                            </div>

                            <footer class="gh-card-footer">
                                <time class="gh-card-date" datetime="${post.published_at}">
                                    ${timeAgo(post.published_at)}
                                </time>
                                ${tagsHTML}
                            </footer>
                        </div>
                    </a>
                </article>
            `;

            // Insert into container
            if (container) {
                container.insertAdjacentHTML('beforeend', postHTML);
            } else {
                // eslint-disable-next-line no-console
                console.warn('post-list element not found!');
            }
        });

        if (result.meta.pagination.next === null) {
            // eslint-disable-next-line no-undef
            document.getElementById('load-more').style.display = 'none';
        }

        loadMoreButton.removeAttribute('disabled');
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
    }
}

function timeAgoFormat(date) {
    const now = new Date();
    const postDate = new Date(date);
    const diff = Math.floor((now - postDate) / 1000); // difference in seconds

    const intervals = [{label: 'an', seconds: 31536000}, {label: 'luni', seconds: 2592000}, {
        label: 'zile', seconds: 86400
    }, {label: 'ore', seconds: 3600}, {label: 'minute', seconds: 60}, {label: 'secunde', seconds: 1}];

    for (const interval of intervals) {
        const count = Math.floor(diff / interval.seconds);
        if (count > 0) {
            return `${count} ${interval.label} în urmă`;
        }
    }

    return 'Acum';
}

function formatFullDate(date) {
    const postDate = new Date(date);

    const options = {
        weekday: 'long', day: 'numeric', month: 'long'
    };

    let formattedDate = new Intl.DateTimeFormat('ro-RO', options).format(postDate);

    formattedDate = formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);

    return formattedDate;
}

function timeAgo(date, group = false) {
    const now = new Date();
    const postDate = new Date(date);

    const diffInMs = now - postDate;
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

    const toDay = now.getDate();
    const postDateDay = postDate.getDate();

    if (toDay === postDateDay) {
        if (group) {
            const options = {
                day: 'numeric', month: 'long'
            };

            let formattedDate = new Intl.DateTimeFormat('ro-RO', options).format(postDate);

            return ((now.getDate() === postDate.getDate()) ? 'Astăzi, ' : 'Ieri, ') + formattedDate;
        }

        return formatFullDate(date);
        // return timeAgoFormat(date);
    } else {
        return formatFullDate(date);
    }
}

// eslint-disable-next-line no-unused-vars,no-undef
const loadMoreButton = document.getElementById('load-more');

if (loadMoreButton) {
    document.getElementById('load-more').addEventListener('click', loadMorePosts);
}

window.addEventListener('scroll', (e) => {
    const scrollEvent = document.getElementsByClassName('gh-container is-list')[0] ?? null;

    if (scrollEvent) {
        const listContainHeight = scrollEvent.offsetHeight;

        if (listContainHeight - window.innerHeight < window.scrollY) {
            if (loadMoreButton && !loadMoreButton.disabled) {
                loadMoreButton.click();

                loadMoreButton.setAttribute('disabled', 'true');
            }
        }
    }
});

// eslint-disable-next-line no-undef
document.addEventListener('DOMContentLoaded', function () {
    // eslint-disable-next-line no-undef
    const aboutMainLink = document.getElementById('about-main');
    // eslint-disable-next-line no-undef
    const aboutMenuLink = document.getElementById('about-menu');
    // eslint-disable-next-line no-undef
    const modal = document.getElementById('modal');
    // eslint-disable-next-line no-undef
    const modalBody = document.getElementById('modal-body');
    // eslint-disable-next-line no-undef
    const modalClose = document.getElementById('modal-close');

    if (aboutMainLink) {
        aboutMainLink.addEventListener('click', function (event) {
            event.preventDefault();

            fetch('/about/')
                .then(response => response.text())
                .then((html) => {
                    // eslint-disable-next-line no-undef
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');

                    const pageContent = doc.querySelector('.gh-content'); // Adjust selector if needed

                    if (pageContent) {
                        modalBody.innerHTML = pageContent.innerHTML;
                        modal.style.display = 'block';
                    } else {
                        modalBody.innerHTML = '<p>Could not load page content.</p>';
                    }
                })
                .catch((err) => {
                    // eslint-disable-next-line no-console
                    console.error('Error loading page:', err);
                    modalBody.innerHTML = '<p>Error loading content.</p>';
                });
        });
    }

    if (aboutMenuLink) {
        aboutMenuLink.addEventListener('click', function (event) {
            event.preventDefault();

            fetch('/about/')
                .then(response => response.text())
                .then((html) => {
                    // eslint-disable-next-line no-undef
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');

                    const pageContent = doc.querySelector('.gh-content'); // Adjust selector if needed

                    if (pageContent) {
                        modalBody.innerHTML = pageContent.innerHTML;
                        modal.style.display = 'block';
                    } else {
                        modalBody.innerHTML = '<p>Could not load page content.</p>';
                    }
                })
                .catch((err) => {
                    // eslint-disable-next-line no-console
                    console.error('Error loading page:', err);
                    modalBody.innerHTML = '<p>Error loading content.</p>';
                });
        });
    }

    if (modalClose) {
        modalClose.addEventListener('click', function () {
            modal.style.display = 'none';
            modalBody.innerHTML = '';
        });
    }

    if (modal) {
        modal.addEventListener('click', function (e) {
            if (e.target === modal) {
                modal.style.display = 'none';
                modalBody.innerHTML = '';
            }
        });
    }

    // eslint-disable-next-line no-undef
    const breakingNews = document.querySelector('.breaking-news.news-slider');

    if (breakingNews) {
        const breakingNewsType = breakingNews.querySelector('.news-item-type');
        const breakingNewsLabel = breakingNewsType.querySelector('.js-type');
        const items = breakingNews.querySelectorAll('.news-slider .news-item');
        const itemCounter = breakingNewsType.querySelector('.counter');

        if (items.length > 1) {
            const breakCount = parseInt(items[0].dataset.brcount);
            const hotCount = parseInt(items[0].dataset.hotcount);
            const order = parseInt(items[0].dataset.order);

            if (breakCount && breakCount > 1) {
                breakingNewsLabel.innerHTML = 'BREAKING NEWS';
                itemCounter.classList.add('visible');
                itemCounter.innerHTML = order + '/' + breakCount;
            }

            if (hotCount && hotCount > 1) {
                breakingNewsLabel.innerHTML = 'NEWS ALERT';
                itemCounter.classList.add('visible');
                itemCounter.innerHTML = order + '/' + hotCount;
            }
        }

        let index = 0;
        items[index].classList.add('active');
        updateNewsLabelAndCounter(items[index]);

        function waitForElementWidth(el, callback) {
            const check = () => {

                if (el.offsetWidth > 0) {
                    callback();
                } else {
                    requestAnimationFrame(check);
                }
            };

            check();
        }

        renderSlide();

        function renderSlide() {
            const newsText = items[index].querySelector('.news-title');

            if (!newsText) {
                nextSlide();

                return;
            }

            const container = items[index].getElementsByClassName('breaking_news_gsap')[0];

            if (newsText.scrollWidth > container.parentNode.offsetWidth) {
                const tickerContent = container.innerHTML.trim();
                container.innerHTML = `${tickerContent} <span style="margin:-6px 15px 0 15px; opacity: .6">|</span> ${tickerContent}`;
                const tickerWidth = container.scrollWidth;

                // container.classList.add('is-scrolling');

                setTimeout(() => {
                    const speed = 100;
                    let tickerOffsetWidth = container.offsetWidth;

                    let initDuration = tickerOffsetWidth / speed;
                    gsap.to(container, {
                        duration: initDuration,
                        x: -(tickerWidth / 2 + 21),
                        ease: "none",
                        repeat: 0,
                        onComplete: (self) => {
                            nextSlide();
                        },
                    });
                }, 1000);
            } else {
                setTimeout(() => {
                    nextSlide();
                }, 6000);
            }
        }

        function nextSlide() {
            setTimeout(() => {
                items[index].style.opacity = 0;

                const nextIndex = (index + 1) % items.length;
                const next = items[nextIndex]
                updateNewsLabelAndCounter(next);

                next.style.opacity = 1;
                next.classList.add('active');

                items[index].classList.remove('active');
                index = nextIndex;

                renderSlide();
            }, 400);
        }

        function updateNewsLabelAndCounter(item) {
            const breakCount = parseInt(item.dataset.brcount);
            const hotCount = parseInt(item.dataset.hotcount);
            const order = parseInt(item.dataset.order);

            if (breakCount) {
                if (breakCount > 1) {
                    itemCounter.classList.add('visible');
                    itemCounter.innerHTML = order + '/' + breakCount;
                } else {
                    itemCounter.classList.remove('visible');
                }

                if (!item.classList.contains('is-hot')) {
                    breakingNewsLabel.innerHTML = 'BREAKING NEWS';
                    breakingNews.classList.remove('is-hot');
                }
            }

            if (hotCount) {
                if (hotCount > 1) {
                    itemCounter.classList.add('visible');
                    itemCounter.innerHTML = order + '/' + hotCount;
                } else {
                    itemCounter.classList.remove('visible');
                }

                if (item.classList.contains('is-hot') && !breakingNews.classList.contains('is-hot')) {
                    breakingNewsLabel.innerHTML = 'NEWS ALERT';
                    breakingNews.classList.add('is-hot');
                }
            }
        }
    }

    document.addEventListener('click', (e) => {
        const tag = e.target.closest('.js-tag-click');
        if (tag) {
            e.preventDefault();
            e.stopPropagation();
            const url = tag.dataset.url;
            if (url) {
                window.location.href = url;
            }
        }
    });

    document.addEventListener('click', (event) => {
        const wrapper = event.target.closest('.source-info-wrapper');

        if (wrapper) {
            event.preventDefault();
            event.stopPropagation();

            const text = wrapper.querySelector('.source-info-text');
            if (text) {
                text.classList.toggle('visible');
            }
        }
    });
});

